/**
 * Bridge.js
 * 适应于壹心理js调用native方法
 *
 * ex:
 * var bridge = new Bridge({
 * 	methods:[
 * 		{
 * 			method: "goBack",
 * 			callback: function(param){}
 * 		}
 * 	]
 * });
 *
 * bridge.call("setTitle",{title:"我是标题"});
 * options.disInitAppHook true为不执行AppHookInit
 */

import getPlatformTools from '../tools/getPlatform'
const { getPlatform } = getPlatformTools

// import vconsole from 'vconsole'
// new vconsole()

// const IS_APP =
//   window.navigator.userAgent.indexOf('yixinliApp') !== -1 ||
//   window.navigator.userAgent.toUpperCase().indexOf('YIXINLICONSULTATIONAPP') !==
//     -1

const BRIDGERESOLVE = '_bridgeResolve'

class Bridge {
  constructor(options) {
    this.tokenStringify = ''
    this.version = '0.1'
    this.platform = getPlatform()
    if (options && !options.disInitAppHook) {
      this.AppHookInit()
    }
    this.ready = null
    if (options && options.methods && options.methods.length) {
      var methods = options.methods
      for (let i = 0; i < methods.length; i++) {
        this.MethodCall(methods[i])
      }
    }
  }

  _init() {}

  add(options) {
    let methods
    if (options && options.methods && options.methods.length) {
      methods = options.methods
    } else if (Array.isArray(options)) {
      methods = options
    } else if (typeof options === 'object') {
      methods = [options]
    }
    if (methods) {
      for (let i = 0; i < methods.length; i++) {
        this.MethodCall(methods[i])
      }
    }
  }

  MethodCall(obj) {
    const ERROR_TITLE = '[Bridge.js] error : '

    let methodName = obj.method

    try {
      if (!methodName) throw `${ERROR_TITLE} method undefined`
      if (!obj.callback) throw `${ERROR_TITLE} callback undefined`
      window[methodName] = (param = '{}') => {
        const formatedParams = JSON.parse(param)
        // if (
        //   !this.tokenStringify &&
        //   Object.prototype.toString.call(formatedParams) === '[object Object]'
        // ) {
        //   let ObjectKeys = Object.keys(formatedParams)
        //   if (ObjectKeys.length === 1 && ObjectKeys[0] === 'token') {
        //     // 缓存getToken返回的json字符串
        //     this.tokenStringify = param
        //   }
        // }

        // 真实的callback接收的是格式化好的参数
        obj.callback(formatedParams)

        // 存在异步resolve方法，释放出来
        let bridgeResolve = window[methodName][BRIDGERESOLVE]
        if (typeof bridgeResolve === 'function') {
          bridgeResolve(formatedParams)
          window[methodName][BRIDGERESOLVE] = null
          console.log(`释放${methodName}的resolve`)
        }
        // getToken的resolveArr
        if (
          Object.prototype.toString.call(bridgeResolve) === '[object Array]'
        ) {
          bridgeResolve.forEach(resolve => {
            resolve(formatedParams)
          })
          window[methodName][BRIDGERESOLVE] = []
          console.log(`释放getTokenArr的resolve`)
        }
      }
    } catch (err) {
      console.error(`${ERROR_TITLE} MethodCall register failed`, err)
    }
  }

  /**
   * call ios function
   * @param  {[string]} callName [协议接口名]
   * @param  {[object]} options  [参数]
   */
  _callIos(callName, options = {}) {
    console.log('@ _callIos', options)
    try {
      options = options ? JSON.stringify(options) : null
      window.webkit.messageHandlers[callName].postMessage(options)
    } catch (err) {
      console.log(err)
    }
  }

  _callAndroid(callName, options = {}) {
    console.log('@ _callAndroid', options)
    try {
      // 这里对options进行统一encode，安卓客户端对options进行统一decode
      // update: 2018/12/18 和安卓确认埋点的时候没有decode，所以前端也不用encode，当时为什么encode已经找不到原因，现在重新注释掉
      // if (properties) {
      //   for (let i in properties) {
      //     properties[i] = encodeURIComponent(properties[i])
      //   }
      //   options.properties = properties
      // }

      options = options ? window.JSON.stringify(options) : ''
      var uri = 'jsbridge://bridege/' + callName + '?' + options
      window.prompt(uri, '')
    } catch (err) {
      console.error(err)
    }
  }

  /**
   * public 调用原生方法 js2native
   * @param  {[string]} callName [方法名称]
   * @param  {[object]} options  [参数]
   */
  call(callName, options = {}) {
    let system =
      this.platform.isiPhone || this.platform.isiPad || this.platform.isiOS
        ? 'Ios'
        : 'Android'
    let callbackName = options.callbackName

    try {
      const platform = getPlatform()
      if (
        !platform.isYixinliApp &&
        !platform.isMuseApp &&
        !platform.isCeShiApp &&
        !platform.isZiXunApp &&
        !platform.isQingSuApp &&
        !platform.isCikeApp &&
        window.navigator.userAgent.indexOf('yixinli') === -1
      ) {
        typeof window.monitor === 'object' &&
          typeof window.monitor.stat === 'function' &&
          window.monitor.stat({
            title: '在非app环境调用bridge！！！！',
            level: 'error',
            logType: 'JSError',
            code: 599
          })
      }
    } catch (e) {
      console.error('bridge 异常日志上报失败', e)
    }

    return new Promise(resolve => {
      if (callbackName && typeof window[callbackName] === 'function') {
        if (callName === 'getToken') {
          let resolveArr = window[callbackName][BRIDGERESOLVE]
          if (resolveArr) {
            resolveArr.push(resolve)
          } else {
            resolveArr = [resolve]
            window[callbackName][BRIDGERESOLVE] = resolveArr
          }
          // 使用缓存的getToken字符串, 模拟App回调
          // if (this.tokenStringify) {
          //   window[callbackName](this.tokenStringify)
          //   return
          // }
        } else {
          // 需要避免多个callName调同一个callback的情况
          window[callbackName][BRIDGERESOLVE] = resolve
        }
      } else {
        // 没有回调的resolve
        resolve()
      }
      this[`_call${system}`](callName, options)
    })
  }

  /**
   * public 移除native调用js的注册接口
   */
  removeMethods() {
    if (this.ots && this.ots.methods && this.ots.methods.length > 0) {
      for (var i = 0; i < this.ots.methods.length; i++) {
        var obj = this.ots.methods[i]
        window[obj.method] = null
      }
    }
  }

  AppHookInit() {
    console.log('初始化APP事件')
    let codeEventMap = {
      10001: 'appShow',
      '10002_0': 'appPayDoneFail',
      '10002_1': 'appPayDoneSuccess',
      10003: 'appWebviewShow',
      10004: 'appWebviewHide'
    }
    let eventFactory = function(code) {
      let eventName = codeEventMap[code]
      return new Event(eventName)
    }

    window.yxlAppCustomEvent = {}
    for (let key in codeEventMap) {
      window.yxlAppCustomEvent[key] = eventFactory(key)
    }

    window.appBecomeActiveStatus = function(optionString) {
      // 使用 window.addEventListener('appPayDoneFail') 之类的触发
      let res = JSON.parse(optionString)
      console.log(
        '派发App事件',
        res.code,
        `Useage: window.addEventListener(${codeEventMap[res.code]})`
      )
      switch (+res.code) {
        case 10002:
          if (res.data.status === 'paySuccess') {
            window.dispatchEvent(window.yxlAppCustomEvent[`10002_1`])
          } else {
            window.dispatchEvent(window.yxlAppCustomEvent[`10002_0`])
          }
          break
        default:
          window.dispatchEvent(window.yxlAppCustomEvent[+res.code])
          break
      }
    }
  }
}

// 供umd引用
try {
  // 非服务端
  if (typeof window !== 'undefined') {
    window.Bridge = Bridge
  }
} catch (e) {
  console.log(e)
}

export default Bridge

/*
var myBridge = new Bridge({
    methods: [{
        method: "test",
        callback: function(param) {
        	alert("hello world");
        }
    }]
});

myBridge.call("setTitle",{title:"我是标题"});
*/



// WEBPACK FOOTER //
// ./src/frontend-lib/lib/Bridge.js